module.exports = __webpack_public_path__ + "img/bjxiangce.1339e255.png";